import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Capacitor } from '@capacitor/core';
import { initializeApp, getApps } from 'firebase/app';

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;
const FCM_TOKEN_KEY = 'fcm_token';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

class FirebaseMessagingService {
  constructor() {
    this.initialized = false;
    this.platform = Capacitor.getPlatform();
    this.token = null;
    this.listeners = [];
  }

  async initialize() {
    if (this.initialized) return;

    try {
      // En web, el plugin delega en la Firebase JS SDK que debe inicializarse primero
      if (this.platform === 'web' && getApps().length === 0) {
        initializeApp(firebaseConfig);
      }

      const { receive } = await FirebaseMessaging.requestPermissions();
      if (receive !== 'granted') return;

      const tokenOptions = this.platform === 'web' ? { vapidKey: VAPID_KEY } : {};
      const { token } = await FirebaseMessaging.getToken(tokenOptions);
      this.token = token;

      if (token) {
        localStorage.setItem(FCM_TOKEN_KEY, token);
        console.info('[FCM] Token (úsalo para probar notificaciones):', token);
      }

      // Suscribir al topic general (solo Android/iOS — web no soporta topics)
      if (this.platform !== 'web') {
        await FirebaseMessaging.subscribeToTopic({ topic: 'all_users' });
      }

      this._registerListeners();
      this.initialized = true;
    } catch (error) {
      console.error('[FCM] Error al inicializar:', error);
    }
  }

  _registerListeners() {
    this.listeners.push(
      FirebaseMessaging.addListener('notificationReceived', (event) => {
        // Notificación recibida con la app en primer plano
        console.log('[FCM] Notificación en foreground:', event.notification);
      })
    );

    this.listeners.push(
      FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
        // Usuario pulsó una notificación (app abierta desde background)
        console.log('[FCM] Notificación pulsada:', event.notification);
      })
    );
  }

  getToken() {
    return this.token || localStorage.getItem(FCM_TOKEN_KEY);
  }
}

export const firebaseMessagingService = new FirebaseMessagingService();
export default firebaseMessagingService;
